enum StatementConciliationActionType {
  CREATE = 'create',
  SEARCH = 'search',
  WRITE_OFF = 'write-off',
  UNDO = 'undo',
}

export default StatementConciliationActionType;
